export const SIZE_GROUPS = [
  { key: 'men', label: 'Мъжки' },
  { key: 'women', label: 'Дамски' },
  { key: 'kids', label: 'Детски' },
];

const KEYS = SIZE_GROUPS.map(g => g.key);

/**
 * Which size selectors a product page should show.
 *
 * `product.sizes` is chosen in the add/edit form. Products saved before that
 * field existed fall back to the old guess based on the type and the name,
 * which is how a set of two mugs ended up asking for a men's and a women's
 * t-shirt size: anything named "комплект" was assumed to be clothing.
 */
export function resolveSizeGroups(product = {}) {
  if (Array.isArray(product.sizes)) {
    return product.sizes
      .filter(s => KEYS.includes(s))
      .map(key => ({ key, required: true }));
  }
  return legacySizeGroups(product);
}

// Categories that are never clothing. A product here asks for no size even if
// its name says "комплект" — "Комплект чаши за баба и дядо" is two mugs, and
// the old name-only rule had it demanding a men's and a women's t-shirt size.
const NON_APPAREL = [
  'чаш', 'картич', 'керамик', 'декупаж', 'месечинк', 'пътечк', 'украса',
  'пъзел', 'ключодържател',
];

/** The pre-`sizes` behaviour, kept so existing products render as before. */
export function legacySizeGroups({ type = '', name = '' } = {}) {
  const t = type.toLowerCase();
  const n = name.toLowerCase();

  if (NON_APPAREL.some(word => t.includes(word))) return [];

  if (t.includes('комплект') || n.includes('комплект')) {
    return [
      { key: 'men', required: true },
      { key: 'women', required: true },
      // Optional because plenty of sets are just two adult shirts.
      { key: 'kids', required: false },
    ];
  }
  if (t.includes('жени')) return [{ key: 'women', required: true }];
  if (t.includes('мъже')) return [{ key: 'men', required: true }];
  if (t.includes('деца')) return [{ key: 'kids', required: true }];
  return [];
}

/** Default checkbox state for a product being added or edited. */
export function defaultSizeKeys(product) {
  return legacySizeGroups(product).map(g => g.key);
}
